/* eslint-disable max-len */
import React from 'react';
import '../../styles/members/about.scss';

/**
 * About section
 */
const About = () => (
  <div className="members-about">
    <div className="section">
      <p>Having worked on different aspects of cases over the years, we are committed to supporting diverse interventions to assist parents and children. NTXFIT focuses on highlighting best practices and growing professional services to better serve the community.</p>
    </div>
  </div>
);

export default About;
